<template>
  <div class="main_div" :key="componentKey">
    <Loading v-show="loading" />
    <div style="height: auto">
      <n-space vertical>
        <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
          <n-space item-style="display: flex;" align="center">
            <div style="font-size: 20px; font-weight: bold">견적 관리</div>
          </n-space>
          <div class="content_delimiter_line"></div>

          <div>
            <n-button type="primary" @click="openOrganizationSelectModal" class="action-button"> 견적서 등록 </n-button>
            <n-tabs type="line" animated v-model:value="currentTab" @update:value="handleTabChange">
              <n-tab-pane :name="TAB.PENDING" :disabled="listLoading">
                <template #tab>
                  <n-space align="center" :size="8" :wrap-item="false">
                    <span>확정 대기 중</span>
                    <n-spin v-if="listLoading && currentTab === TAB.PENDING" size="small" />
                  </n-space>
                </template>
                <n-space vertical style="margin-top: 10px">
                  <n-space align="baseline" item-style="display: flex;">
                    <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                      <n-input-group>
                        <n-select v-model:value="searchTypeForPending" :options="searchOptions" style="width: 120px" />
                        <n-input v-model:value="searchValueForPending" placeholder="검색어를 입력하세요" clearable />
                      </n-input-group>
                    </n-form-item>
                    <n-form-item style="min-width: 300px" label-placement="left"> </n-form-item>
                    <n-form-item style="margin-bottom: 0">
                      <n-button type="primary" @click="wrappedRefreshOrders"> 조회 </n-button>
                    </n-form-item>
                  </n-space>
                </n-space>
                <div v-if="listLoading" class="loading-indicator">견적 목록을 불러오는 중...</div>
                <div v-if="error" class="error-message">{{ error }}</div>
                <div v-if="!listLoading && !error">
                  <div class="table-container">
                    <n-data-table
                      v-if="orders.length > 0"
                      :columns="pendingColumns"
                      :data="orders"
                      :pagination="false"
                      :bordered="true"
                    />
                    <p v-else>등록된 견적이 없습니다.</p>
                  </div>
                  <div
                    v-if="orders.length > 0 && !listLoading && !error"
                    class="pagination-controls"
                    style="margin-top: 15px; text-align: center"
                  >
                    <n-button @click="wrappedGoToPreviousPage" :disabled="currentPage === 1" style="margin-right: 8px">
                      이전 페이지
                    </n-button>
                    <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                    <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                  </div>
                </div>
              </n-tab-pane>
              <n-tab-pane :name="TAB.APPROVED" :disabled="listLoading">
                <template #tab>
                  <n-space align="center" :size="8" :wrap-item="false">
                    <span>확정 완료</span>
                    <n-spin v-if="listLoading && currentTab === TAB.APPROVED" size="small" />
                  </n-space>
                </template>
                <n-space vertical style="margin-top: 10px">
                  <n-space align="baseline" item-style="display: flex;">
                    <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                      <n-input-group>
                        <n-select v-model:value="searchTypeForAccepted" :options="searchOptions" style="width: 120px" />
                        <n-input v-model:value="searchValueForAccepted" placeholder="검색어를 입력하세요" clearable />
                      </n-input-group>
                    </n-form-item>
                    <n-form-item label="견적 등록일" style="min-width: 300px" label-placement="left">
                      <n-date-picker v-model:value="dateRangeForAccepted" type="daterange" clearable />
                    </n-form-item>
                    <n-form-item style="margin-bottom: 0">
                      <n-button type="primary" @click="fetchAcceptedOrders" :disabled="!isSearchEnabled">
                        조회
                      </n-button>
                    </n-form-item>
                  </n-space>
                </n-space>

                <div v-if="showAcceptedResults">
                  <Loading v-show="listLoading && currentTab === TAB.APPROVED" />
                  <div
                    v-if="!listLoading && error && currentTab === TAB.APPROVED"
                    class="error-message"
                    style="margin-top: 10px"
                  >
                    {{ error }}
                  </div>
                  <n-data-table
                    v-if="!listLoading && !error && orders.length > 0 && currentTab === TAB.APPROVED"
                    :columns="completedColumns"
                    :data="orders"
                    :pagination="false"
                    :bordered="true"
                    style="margin-top: 10px"
                  />
                  <p
                    v-if="!listLoading && !error && orders.length === 0 && currentTab === TAB.APPROVED"
                    style="margin-top: 10px; text-align: center"
                  >
                    선택된 기간에 등록된 견적이 없습니다.
                  </p>

                  <div
                    v-if="orders.length > 0 && !listLoading && !error"
                    class="pagination-controls"
                    style="margin-top: 15px; text-align: center"
                  >
                    <n-button @click="wrappedGoToPreviousPage" :disabled="currentPage === 1" style="margin-right: 8px">
                      이전 페이지
                    </n-button>
                    <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                    <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                  </div>
                </div>
                <div v-else style="margin-top: 20px; text-align: center; color: #777">
                  검색 조건을 지정한 후 조회 하세요.
                </div>
              </n-tab-pane>
            </n-tabs>
          </div>
        </NCard>

        <!-- 기관 선택 모달 -->
        <n-modal
          v-model:show="showOrgSelectModal"
          preset="card"
          style="width: 600px"
          title="견적 대상 기관 선택"
          @after-leave="onOrgSelectModalClose"
        >
          <div v-if="orgListLoading" class="loading-indicator">기관 목록을 불러오는 중...</div>
          <div v-if="orgListError" class="error-message">{{ orgListError }}</div>
          <div v-if="!orgListLoading && !orgListError">
            <n-select
              v-model:value="selectedOrgForOrder"
              placeholder="기관을 선택하세요"
              :options="organizationOptions"
              label-field="name"
              value-field="SK"
              filterable
              clearable
              style="margin-bottom: 20px"
            />
            <div style="text-align: right">
              <n-button @click="closeOrganizationSelectModal" type="tertiary" style="margin-right: 10px">
                취소
              </n-button>
              <n-button type="primary" @click="confirmOrganizationSelection" :disabled="!selectedOrgForOrder">
                확인
              </n-button>
            </div>
          </div>
        </n-modal>

        <!-- 견적 상세 정보 모달 -->
        <n-modal
          v-model:show="showOrderDetailsModal"
          preset="card"
          style="width: 800px"
          title="견적 상세 정보"
          @after-leave="onOrderDetailsModalClose"
        >
          <div v-if="selectedOrder" class="order-details-content">
            <n-descriptions label-placement="left" bordered :column="2" size="small">
              <n-descriptions-item label="견적명" :span="2">{{ selectedOrder.name }}</n-descriptions-item>
              <n-descriptions-item label="기관명">{{ selectedOrder.client.name }}</n-descriptions-item>
              <n-descriptions-item label="수신자 이메일">{{ selectedOrder.receiver_email }}</n-descriptions-item>
              <n-descriptions-item label="담당부서">{{ selectedOrder.client.dept || "N/A" }}</n-descriptions-item>
              <n-descriptions-item label="담당자">{{
                selectedOrder.client.deptPersonName || "N/A"
              }}</n-descriptions-item>
              <n-descriptions-item label="상태">{{ common.getStatusString(selectedOrder.status) }}</n-descriptions-item>
              <n-descriptions-item label="생성일">
                {{ common.getYYYYMMDD2(new Date(Number(selectedOrder.createdDate))) }}
              </n-descriptions-item>
              <n-descriptions-item label="총 금액" span="2"
                >{{ common.formatNumberWithCommas(selectedOrder.totalPrice) }}원</n-descriptions-item
              >
              <n-descriptions-item label="결제 방법" :span="2">
                {{
                  selectedOrder.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.payment_method?.type || "N/A"
                }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="결제 계좌"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금자명"
                :span="2"
              >
                {{ selectedOrder.payment_method.deposit_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금예정일"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_date }}
              </n-descriptions-item>
              <n-descriptions-item label="견적서" :span="2">
                <n-button
                  v-if="selectedOrder.quotation_pdf"
                  size="small"
                  tertiary
                  @click="onFileDonwload(selectedOrder!)"
                >
                  다운로드 ({{ selectedOrder.name }}.pdf)
                </n-button>
                <span v-else>첨부된 견적서 없음</span>
              </n-descriptions-item>
            </n-descriptions>

            <h4 style="margin-top: 20px; margin-bottom: 10px">견적 항목</h4>
            <n-data-table
              :columns="orderItemColumns"
              :data="selectedOrder.products"
              :pagination="false"
              :bordered="true"
              size="small"
            />

            <div style="text-align: right; margin-top: 20px">
              <n-button @click="closeOrderDetailsModal" type="tertiary" style="margin-right: 10px"> 닫기 </n-button>
              <n-button
                v-if="isPendingOrder"
                type="primary"
                @click="confirmOrder(selectedOrder.SK)"
                :disabled="selectedOrder.status !== constant.orderStatus.PENDING"
                style="margin-right: 10px"
              >
                견적확정
              </n-button>
              <n-button
                v-if="isPendingOrder"
                type="primary"
                @click="cancelOrder(selectedOrder.SK)"
                :disabled="selectedOrder.status !== constant.orderStatus.PENDING"
              >
                견적취소
              </n-button>
            </div>
          </div>
          <div v-else class="loading-indicator">상세 정보를 불러오는 중...</div>
        </n-modal>
      </n-space>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, computed } from "vue";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  useNotification,
  useDialog,
  NTabs,
  NTabPane,
  NFormItem,
  NDatePicker,
  NSpin,
  NInputGroup,
  NInput,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { ChangeStatus } from "@/model/base";
import { Order } from "@/model/order";
import { Organization } from "@/model/organization";
import { QueryInfo } from "@/model/common"; // QueryInfo 임포트
import { useOrderApi } from "@/composables/useOrderForm";
import { USER_ROUTES } from "@/assets/route_constants";
import { usePagination } from "@/composables/usePagination"; // usePagination 임포트
import { useActionDialog } from "@/composables/useDialog";
import { useDownload } from "@/composables/useDownload";
const { downloadQuotationFile } = useDownload();
const { show: showActionDialog } = useActionDialog();
const { deleteOrder } = useOrderApi();

const TAB = {
  PENDING: "pending",
  APPROVED: "approved",
};
const currentTab = ref(TAB.PENDING);
const dateRangeForAccepted = ref<[number, number] | null>(null);
const showAcceptedResults = ref(false);

const { loading } = useAuth(); // 전역 로딩 상태
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const componentKey = ref(0); // To force re-render if needed
const showOrgSelectModal = ref(false);
const organizationsForSelect = ref<Organization[]>([]);
const selectedOrgForOrder = ref<string | null>(null); // 선택된 기관의 SK
const orgListLoading = ref(false);
const orgListError = ref<string | null>(null);
const showOrderDetailsModal = ref(false);
const selectedOrder = ref<Order | null>(null);
const searchValueForPending = ref<string | null>(null);
const searchTypeForPending = ref("name");
const searchValueForAccepted = ref<string | null>(null);
const searchTypeForAccepted = ref("name");
const isPendingOrder = ref(false);

const getOrdersCallable = getCallable("getOrgOrders");
const getOrgsCallable = getCallable("getOrgs");
const getCallApiCallable = getCallable("callApi");
const changeOrderStatusFunc = "changeOrderStatus";

const searchOptions = [
  { label: "견적명", value: "name" },
  { label: "기관명", value: "client.name" },
  { label: "담당자", value: "client.deptPersonName" },
];

const isSearchEnabled = computed(() => {
  return (
    dateRangeForAccepted.value !== null || (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "")
  );
});

const baseColumns = [
  { title: "기관명", key: "client.name", resizable: true },
  { title: "견적명", key: "name", resizable: true },
  { title: "담당부서", key: "client.dept", resizable: true },
  { title: "담당자", key: "client.deptPersonName", resizable: true },
  {
    title: "총 금액",
    key: "totalPrice",
    resizable: true,
    render: (row: Order) => {
      const priceStr = common.formatNumberWithCommas(row.totalPrice);
      return `${priceStr} 원`;
    },
  },
  { title: "상태", key: "status", resizable: true, render: (row: Order) => `${common.getStatusString(row.status)}` },
  {
    title: "생성일",
    key: "createdDate",
    resizable: true,
    render: (row: Order) => {
      const timestamp = Number(row.createdDate);
      if (!isNaN(timestamp)) {
        const date = new Date(timestamp);
        return common.getYYYYMMDD2(date);
      }
      return row.createdDate || "N/A";
    },
  },
];

const pendingColumns = [
  ...baseColumns,
  {
    title: "",
    key: "actions",
    render(row: Order) {
      const buttons: any = [];
      buttons.push(
        h(
          NButton,
          {
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => displayOrderDetails(row, true),
          },
          { default: () => "상세" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => goToEditOrder(row.SK),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "수정" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => confirmOrder(row.SK),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "확정" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => cancelOrder(row.SK),
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "취소" }
        )
      );
      buttons.push(
        h(
          NButton,
          {
            style: "margin-left: 10px",
            strong: true,
            tertiary: true,
            size: "small",
            type: "error",
            onClick: () => {
              deleteOrder(row.SK, false).then((success) => {
                // `deleteOrder` composable이 성공 메시지를 처리한다고 가정
                if (success) {
                  // orders.value = orders.value.filter((order) => order.SK !== row.SK);
                  // 데이터 변경 후 목록 새로고침
                  wrappedRefreshOrders();
                }
              });
            },
            disabled: row.status !== constant.orderStatus.PENDING,
          },
          { default: () => "삭제" }
        )
      );
      return buttons;
    },
  },
];

const completedColumns = [
  ...baseColumns,
  {
    title: "",
    key: "actions",
    render(row: Order) {
      const buttons: any = [];
      buttons.push(
        h(
          NButton,
          {
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => displayOrderDetails(row, false),
          },
          { default: () => "상세" }
        )
      );
      return buttons;
    },
  },
];

const orderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "단가",
    key: "unit_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.unit_price || 0).toLocaleString()}원`,
  },
  { title: "수량", key: "quantity", resizable: true },
  {
    title: "공급가액",
    key: "supply_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.supply_price || 0).toLocaleString()}원`,
  },
  {
    title: "비고",
    key: "notes",
    resizable: true,
    render: (row: OrderItem) => `${row.notes || ""}`,
  },
];

async function fetchAcceptedOrders() {
  if (!isSearchEnabled.value) {
    message.error("조회 조건을 하나 이상 입력해주세요.");
    return;
  }

  const searchParams: { startDate?: string; endDate?: string; searchKey?: string; searchValue?: string } = {};

  if (dateRangeForAccepted.value) {
    const [startTimestamp, endTimestamp] = dateRangeForAccepted.value;
    searchParams.startDate = startTimestamp.toString();
    searchParams.endDate = common.addDaysToTimestamp(endTimestamp, 1).toString();
  }

  if (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "") {
    searchParams.searchKey = searchTypeForAccepted.value;
    searchParams.searchValue = searchValueForAccepted.value.trim();
  }

  showAcceptedResults.value = false;
  await refreshData(searchParams);
  showAcceptedResults.value = true;
}

const getOrders = async (params: any) => {
  const queryParams: any = { ...params };

  if (currentTab.value === TAB.PENDING) {
    queryParams.status = constant.orderStatus.PENDING;
    return getOrdersCallable(queryParams);
  } else if (currentTab.value === TAB.APPROVED) {
    queryParams.status = constant.orderStatus.APPROVED;
    const hasDateRange = params.startDate && params.endDate;
    const hasSearchValue = params.searchKey && params.searchValue;

    if (hasDateRange || hasSearchValue) {
      if (hasDateRange) {
        queryParams.startDate = params.startDate;
        queryParams.endDate = params.endDate;
      }
      if (hasSearchValue) {
        queryParams.searchKey = params.searchKey;
        queryParams.searchValue = params.searchValue;
      }
      return getOrdersCallable(queryParams);
    } else {
      return { data: { Items: [], LastEvaluatedKey: null } };
    }
  }
};

const {
  paginatedItems: orders,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage,
  goToPreviousPage,
  refreshData,
} = usePagination<
  Order,
  { status?: string; startDate?: string; endDate?: string; searchKey?: string; searchValue?: string }
>(
  getOrders,
  10 // 페이지 크기
);

// 전역 로딩 상태를 포함하는 래퍼 함수들
async function wrappedRefreshOrders() {
  loading.value = true;
  const searchParams: { searchKey?: string; searchValue?: string } = {};

  if (searchValueForPending.value && searchValueForPending.value.trim() !== "") {
    searchParams.searchKey = searchTypeForPending.value;
    searchParams.searchValue = searchValueForPending.value.trim();
  }
  await refreshData(searchParams);
  loading.value = false;
}

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  loading.value = true;
  await goToNextPage();
  loading.value = false;
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  loading.value = true;
  await goToPreviousPage();
  loading.value = false;
}

async function fetchOrganizationsForSelect() {
  loading.value = true;
  orgListLoading.value = true;
  orgListError.value = null;
  try {
    const result = await getOrgsCallable({});
    organizationsForSelect.value = common.getItemListFromFunctionResult(result);
  } catch (err: any) {
    console.error("기관 목록(선택용) 로딩 실패:", err);
    orgListError.value = "기관 목록을 불러오는데 실패했습니다.";
  } finally {
    orgListLoading.value = false;
    loading.value = false;
  }
}

const organizationOptions = computed(() => organizationsForSelect.value);

function openOrganizationSelectModal() {
  selectedOrgForOrder.value = null;
  showOrgSelectModal.value = true;
  if (organizationsForSelect.value.length === 0) {
    fetchOrganizationsForSelect();
  }
}

function closeOrganizationSelectModal() {
  showOrgSelectModal.value = false;
}

async function displayOrderDetails(order: Order, isPending: boolean) {
  selectedOrder.value = order;
  isPendingOrder.value = isPending;
  showOrderDetailsModal.value = true;
}

function closeOrderDetailsModal() {
  showOrderDetailsModal.value = false;
}

function onOrgSelectModalClose() {
  selectedOrgForOrder.value = null;
}
function onOrderDetailsModalClose() {
  selectedOrder.value = null; // 상세 정보 초기화
}

function goToEditOrder(orderSK: string) {
  router.push({ name: USER_ROUTES.OrgOrderEdit.Name, params: { SK: orderSK } });
}

async function changeOrderStatus(orderSK: string, status: constant.orderStatus) {
  let job: string | null = null;
  if (status == constant.orderStatus.APPROVED) {
    job = "확정";
  } else if (status == constant.orderStatus.CANCELED) {
    job = "취소";
  } else {
    return;
  }
  showActionDialog({
    title: `견적 ${job}`,
    content: `이 견적을 ${job} 하시겠습니까? ${job} 후에는 수정할 수 없습니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: `${job} 중...`,
    onConfirm: async () => {
      const data: ChangeStatus = {
        SK: orderSK,
        status: status,
      };
      const payload: {
        status: constant.orderStatus;
        type: constant.orderType;
        data: ChangeStatus;
      } = {
        status: status,
        type: constant.orderType.BODY,
        data: data,
      };
      const result = await getCallApiCallable(makeCallApiParam(changeOrderStatusFunc, payload));
      if (common.evalFunctionResult(result)) {
        message.success(`견적이 성공적으로 ${job} 되었습니다.`);
        const orderIndex = orders.value.findIndex((o) => o.SK === orderSK);
        if (orderIndex !== -1 && orders.value[orderIndex]) {
          orders.value[orderIndex].status = status;
        }
      } else {
        message.success(common.getResultError(result) || `견적 ${job} 중 오류가 발생했습니다.`);
      }
      return;
    },
  });
}

async function cancelOrder(orderSK: string) {
  changeOrderStatus(orderSK, constant.orderStatus.CANCELED);
}

async function confirmOrder(orderSK: string) {
  changeOrderStatus(orderSK, constant.orderStatus.APPROVED);
}

function confirmOrganizationSelection() {
  if (selectedOrgForOrder.value) {
    router.push({
      name: USER_ROUTES.OrgOrderRegister.Name,
      params: { SK: selectedOrgForOrder.value },
      query: { origin: USER_ROUTES.OrgOrder.Name },
    });
    closeOrganizationSelectModal();
  } else {
    message.warning("기관을 선택해주세요.");
  }
}

async function onFileDonwload(row: Order) {
  loading.value = true;
  await downloadQuotationFile(row.quotation_pdf, row.name);
  loading.value = false;
}

async function handleTabChange(tabName: string) {
  currentTab.value = tabName;
  orders.value = [];
  error.value = null;
  if (tabName === TAB.APPROVED) {
    showAcceptedResults.value = false;
    dateRangeForAccepted.value = null;
    searchValueForAccepted.value = null;
    searchTypeForAccepted.value = "name";
  } else {
    searchValueForPending.value = null;
    searchTypeForPending.value = "name";
    await wrappedRefreshOrders();
  }
}

onMounted(() => {
  if (currentTab.value === TAB.PENDING) {
    wrappedRefreshOrders(); // 초기 데이터 로드
  }
});
</script>

<style scope></style>
